import { trpc } from '@tencent/tpro_rmonitor_web_server_traffic';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

type IGetReportListReq = WithTypeCast<trpc.rmonitor.web_server.IGetReportListReq>;
type IGetReportListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetReportListRsp>;
type IGetProblemDetailReq = WithTypeCast<trpc.rmonitor.web_server.IGetProblemDetailReq>;
type IDetailInfo = WithTypeCast<trpc.rmonitor.web_server.IDetailInfo>;

/**
 * 产品成员管理
 */
export class TrafficService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.TrafficService,
    });
  }

  public async getReportList(req: IGetReportListReq): Promise<IGetReportListRsp | null> {
    try {
      return await this.trpcPost('GetReportList', req);
    } catch (e) {
      return null;
    }
  }

  public async getProblemDetail(req: IGetProblemDetailReq): Promise<IDetailInfo | null> {
    try {
      const rsp = await this.trpcPost('GetProblemDetail', req);
      return get(rsp, 'detail', null);
    } catch (e) {
      return null;
    }
  }
}

export const trafficService = new TrafficService();
